import { required, maxLength, minLength, numeric, integer, minValue, maxValue, helpers, requiredIf } from '@vuelidate/validators';
import i18n from "@/plugins/i18n";

export default function (formState) {
  return {
    form: {
      name: {
        required: helpers.withMessage(i18n.global.t('Please enter a inventory name.'), required),
        maxLength: helpers.withMessage(
          ({
            $params,
          }) => i18n.global.t('Inventory name cannot exceed') +  ' ' + $params.max + ' ' + i18n.global.t('characters.'),
          maxLength(255)
        ),
        minLength: helpers.withMessage(
          ({
            $params,
          }) => i18n.global.t('Inventory name must be at least') +  ' ' + $params.min + ' ' + i18n.global.t('characters long.'),
          minLength(3)
        ),
        pattern: helpers.withMessage(i18n.global.t('Inventory names can include Thai, English, and numeric characters, as well as certain special characters.'), helpers.regex(/^[A-Zก-๙a-z0-9-_/& ]+$/)),
      },
      code: {
        // required: helpers.withMessage(i18n.global.t('Please enter a inventory code.'), required),
        maxLength: helpers.withMessage(
          ({
            $params,
          }) => i18n.global.t('Inventory code cannot exceed') +  ' ' + $params.max + ' ' + i18n.global.t('characters.'),
          maxLength(255)
        ),
        minLength: helpers.withMessage(
          ({
            $params,
          }) => i18n.global.t('Inventory code must be at least') +  ' ' + $params.min + ' ' + i18n.global.t('characters long.'),
          minLength(3)
        ),
        pattern: helpers.withMessage(i18n.global.t('Inventory names can include Thai, English, and numeric characters, as well as certain special characters.'), helpers.regex(/^[A-Zก-๙a-z0-9-_/& ]+$/)),
      },
      quantity: {
        required: helpers.withMessage(i18n.global.t('Please enter a inventory quantity.'), required),
        numeric: helpers.withMessage(i18n.global.t('Please enter a valid number for the inventory quantity.'), numeric)
      },
      cost: {
        required: helpers.withMessage(i18n.global.t('Please enter a inventory unit cost.'), required),
        numeric: helpers.withMessage(i18n.global.t('Please enter a valid number for the inventory unit cost.'), numeric)
      },
      cost_manual: {},
      storage_condition: {
        required: required,
      },
      type: {
        required: required,
      },
      unit_id: {
        required: required,
      },
      inventory_category_id: {
        required: required,
      },
      tax_status: {
        required: required,
      },
      initial_stock_branch_id: {
        required: requiredIf(formState.initial_stock_add),
      },
      initial_stock_quantity: {
        required: helpers.withMessage(i18n.global.t('Please enter a quantity.'), requiredIf(formState.initial_stock_add)),
        numeric: helpers.withMessage(i18n.global.t('Please enter a valid number for the quantity.'), numeric),
        minValue: helpers.withMessage(
          ({
            $params,
          }) => i18n.global.t('quantity must be at least') +  ' ' + $params.min,
          minValue(formState.initial_stock_add? 0.0001: 0)
        ),
      },
      initial_stock_cost: {
        required: helpers.withMessage(i18n.global.t('Please enter a cost.'), requiredIf(formState.initial_stock_add)),
        numeric: helpers.withMessage(i18n.global.t('Please enter a valid number for the cost.'), numeric)
      },
      initial_stock_received_date: {
        required: requiredIf(formState.initial_stock_add),
      },
      initial_stock_expiry_date: {
        required: requiredIf(formState.initial_stock_add),
      },
    }
  }
};
